/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import birdata from "../api.js";
import _ from "underscore";

var SurveyReviewViewModel = function(params) {
	var self = this;

  var survey = self.survey = params.parent.survey;

  function allValidations() {
    return _.flatten([
      survey.validations,
      survey.dynamicValidations(),
      Object.keys(survey.extensionData).map(code => survey.extensionData[code].validations()),
      _.map(survey.sightings(), function(sighting) {return sighting.validations(); })
    ]);
  }

  self.errors = ko.pureComputed(function() {
    return _.chain(allValidations())
    .map(function(v) {
      return {
        message: v.fullError(),
        tab: v.validateInfo ? v.validateInfo.tab : 'details'
      };
    })
    .filter(function(v) { return !!v.message; })
    .uniq(function(v) { return v.message; })
    .value();
  });

  self.clickIssue = function(issue) {
    params.parent.showTab(issue.tab || 'details');
  };

  self.visible = ko.pureComputed(function() {
    return params.parent.currentSection().component.name == "survey-edit-review";
  });

  // Once we've been to the review tab, ensure all validation errors are shown on other tabs
  ko.computed(function() {
    if(self.visible()) {
      _.each(allValidations(), function(v) {
        v.showError(true);
      });
    }
  });

  self.speciesURL = function(species) {
    return  birdata.speciesImageURL(species.id, 'small_square');
  };

  self.submitInProgress = params.parent.submitInProgress;
  self.submitError = ko.observable(null);
  self.showErrorDetail = ko.observable(false);
  self.submitComplete = params.parent.submitComplete;
  self.surveyReferenceID = params.parent.surveyReferenceID;
  self.areaSurveyReferenceID = params.parent.areaSurveyReferenceID;

  self.canSubmit = ko.pureComputed(function() {
    return self.errors().length == 0 && !self.submitInProgress() && !self.submitComplete();
  });

  self.submit = function() {
    if(self.submitInProgress()) return;

    var surveyJSON = survey.toJSON();

    // surveyJSON.foo = 'bar'; // force error

    self.submitError(null);
    self.submitInProgress(true);
    birdata.submitSurvey(surveyJSON, survey.existing()).then(function(result) {
      if(survey.isEmbedded()) {
        self.surveyReferenceID(_.findWhere(result, { survey_type: "2_ha_search" }).id);
        self.areaSurveyReferenceID(_.findWhere(result, { survey_type: "area_search_within_500_m"}).id);
      } else {
        self.surveyReferenceID(result[0].id);
      }
      self.submitInProgress(false);
      self.submitComplete(true);

      // Lookup share URL:
      birdata.surveyShareURL(result[0].id).then(function(result) {
        var url = "http://birdata.birdlife.org.au" + result.url
        params.parent.surveyShareURL(url);
      });
    }).catch(function(error, b, c) {
      console.log(error);

      error = (error.xhr && error.xhr.responseText) || error.message || 'Unable to contact server';

      self.submitInProgress(false);
      self.showErrorDetail(false);

      try {
        var errorJson = JSON.parse(error);
        error = JSON.stringify(errorJson, null, 2);
      } catch(e) {
        // 'error' was not a JSON string - ignore and continue
      }

      self.submitError(error);
    });

    console.log(JSON.stringify(surveyJSON, null, 2));
  };
};

ko.components.register('survey-edit-review', {
	viewModel: SurveyReviewViewModel,
	template: require('../../templates/survey-edit-review.html')
});

export default SurveyReviewViewModel;
